import { render } from "./GettingStarted.vue?vue&type=template&id=92e8ee30&scoped=true"
import script from "./GettingStarted.vue?vue&type=script&lang=js"
export * from "./GettingStarted.vue?vue&type=script&lang=js"

import "./GettingStarted.vue?vue&type=style&index=0&id=92e8ee30&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-92e8ee30"]])

export default __exports__